import { useAuth } from "../context/auth";
import { Login, Logout } from "@mui/icons-material";
import ZownLogo from "../assets/zown-logo-white-wide.svg";
import { AppBar, Box, Button, Toolbar } from "@mui/material";
import { useNavigate, useLocation } from "@tanstack/react-router";

const TopBar = () => {
  const navigate = useNavigate({ from: "/" });
  const location = useLocation();
  const { isAuthenticated, login, logout } = useAuth();

  const showBuyer = () => {
    navigate({ to: "/buyers" });
  };

  // const showAgent = () => {
  //   navigate({ to: "/agents" });
  // }

  const showCalls = () => {
    navigate({ to: "/calls" });
  };


  const showReferrals = () => {
    navigate({ to: "/referrals" });
  };

  const currentSection = location.pathname.split("/")[1];

  return (
    <AppBar position="static" sx={{ backgroundColor: "#333" }}>
      <Toolbar>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            alignItems: "center"
          }}
        >
          <Box
            component="img"
            src={ZownLogo}
            alt="Zown Logo"
            sx={{
              maxHeight: "30px",
              display: "block",
              marginTop: "5px"
            }}
          />
          {isAuthenticated && (
            <>
              <Button
                onClick={showBuyer}
                sx={{
                  textTransform: "none",
                  marginLeft: 2,
                  color:
                    currentSection === "buyers" ? "primary.main" : "inherit",
                  fontWeight: currentSection === "buyers" ? "bold" : "normal"
                }}
              >
                Buyers
              </Button>

              {/* <Button
                onClick={showAgent}
                sx={{
                  textTransform: "none",
                  marginLeft: 2,
                  color: currentSection === "agents" ? "primary.main" : "inherit",
                  fontWeight: currentSection === "agents" ? "bold" : "normal"
                }}
              >
                Agents
              </Button> */}
              <Button
                onClick={showCalls}
                sx={{
                  textTransform: "none",
                  marginLeft: 2,
                  color:
                    currentSection === "calls" ? "primary.main" : "inherit",
                  fontWeight: currentSection === "calls" ? "bold" : "normal"
                }}
              >
                Calls
              </Button>
              <Button
                onClick={showReferrals}
                sx={{
                  textTransform: "none",
                  marginLeft: 2,
                  color:
                    currentSection === "referrals" ? "primary.main" : "inherit",
                  fontWeight: currentSection === "referrals" ? "bold" : "normal"
                }}
              >
                Referrals
              </Button>
            </>
          )}
        </Box>
        {isAuthenticated && (
          <Button
            color="inherit"
            onClick={() => logout()}
            startIcon={<Logout />}
            sx={{ textTransform: "none" }}
          >
            Log Out
          </Button>
        )}
        {!isAuthenticated && (
          <Button
            color="inherit"
            onClick={() => login()}
            startIcon={<Login />}
            sx={{ textTransform: "none" }}
          >
            Log In
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
};

export { TopBar };
